import Property from '../../../model/Property';
import { getPhotoUrls } from '../../../utils/propertiesPageUtils';

const mockListings = {
  singleListingArray: [
    Property({
      listingAlias: 'kgw3q1907c50',
      status: {
        message: '',
        code: '',
        text: 'Publishing',
        tagAppearance: 'warning',
        status: 'PUBLISHING',
      },
      photoUrls: {
        medium: 'https://photos.test.zillow.net/fp/88f8dbf4e5813d1750d5ae50ca9c065e-rentals_medium_500_500.webp',
        thumb: 'https://photos.test.zillow.net/fp/88f8dbf4e5813d1750d5ae50ca9c065e-rentals_thumb_180_180.webp',
      },
      name: '5308 Foxfire Rd',
      address: {
        state: 'NC',
        city: 'Fayetteville',
        zip: '28303',
        street: '5308 Foxfire Rd',
        unit: '',
      },
      isMultifamily: false,
    }),
  ],
  twoListingArray: [
    Property({
      listingAlias: 'kgw3q1907c50',
      status: {
        message: '',
        code: '',
        text: 'Publishing',
        tagAppearance: 'warning',
        status: 'PUBLISHING',
      },
      photoUrls: {
        medium: 'https://photos.test.zillow.net/fp/88f8dbf4e5813d1750d5ae50ca9c065e-rentals_medium_500_500.webp',
        thumb: 'https://photos.test.zillow.net/fp/88f8dbf4e5813d1750d5ae50ca9c065e-rentals_thumb_180_180.webp',
      },
      name: '5308 Foxfire Rd',
      address: {
        state: 'NC',
        city: 'Fayetteville',
        zip: '28303',
        street: '5308 Foxfire Rd',
        unit: '',
      },
      isMultifamily: false,
    }),
    Property({
      listingAlias: '297pp0w535g3u',
      status: {
        message: '',
        code: '',
        text: 'Publishing',
        tagAppearance: 'warning',
        status: 'PUBLISHING',
      },
      photoUrls: {
        medium: '"https://photos.test.zillow.net/fp/694da527ae971a76a74c4979db465c53-rentals_medium_500_500.webp"',
        thumb: 'https://photos.test.zillow.net/fp/694da527ae971a76a74c4979db465c53-rentals_thumb_180_180.webp',
      },
      name: '3000 Green Rd',
      address: {
        state: 'FL',
        city: 'Green Cove Springs',
        zip: '32043',
        street: '1407 North St',
        unit: '',
      },
      isMultifamily: false,
    }),
  ],
  activeListing: Property({
    listingAlias: '1mkv9hrudhthd',
    status: {
      status: 'PUBLISHED',
      text: 'Listed 7 days',
    },
    photoUrls: getPhotoUrls(false, '19a033d27ed5a6fb9f59776f1c914b36'),
    name: '14023 Village Terrace Dr',
    address: {
      state: 'FL',
      city: 'Tampa',
      zip: '33624',
      street: '14023 Village Terrace Dr',
      unit: '',
    },
    isMultifamily: false,
  }),
  inactiveListing: Property({
    listingAlias: '14pd6ytp02g6s',
    status: {
      status: 'OFF_MARKET',
      text: 'Off-market',
    },
    name: '9850 S Thomas Dr #2A',
    address: {
      state: 'FL',
      city: 'Panama City',
      zip: '32408',
      street: '9850 S Thomas Dr',
      unit: '2A',
    },
    isMultifamily: false,
  }),
  multifamilyListing: Property({
    listingAlias: '4ueccrkznt70m',
    status: {
      status: 'OFF_MARKET',
      text: 'Off-market',
    },
    name: 'ridens',
    address: {
      state: 'TX',
      city: 'Austin',
      zip: '78751',
      street: '100 E 52nd St',
      unit: '',
    },
    isMultifamily: true,
  }),
  archivedListing: Property({
    listingAlias: '1t46tt48f8rv6',
    status: {
      status: 'ARCHIVED',
      text: 'Archived',
    },
    photoUrls: getPhotoUrls(false, '299c937b956e90a69dc37bfe91f63659'),
    name: 'maximus',
    address: {
      state: 'CA',
      city: 'Vacaville',
      zip: '95687',
      street: '1816 Quail Meadows Cir',
      unit: '',
    },
    isMultifamily: true,
  }),
};

export default mockListings;
